"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-autofocus */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const isEmail_1 = __importDefault(require("~/utils/isEmail"));
const EmailsInput_module_scss_1 = __importDefault(require("./EmailsInput.module.scss"));
function EmailsInput({ isSubmitted, submitHandler, disableSubmit, errors, editErrors }) {
    const { t } = (0, react_i18next_1.useTranslation)('account');
    const inputRef = (0, react_1.useRef)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    const [emails, setEmails] = (0, react_1.useState)([]);
    const [email, setEmail] = (0, react_1.useState)('');
    const [emailError, setEmailError] = (0, react_1.useState)(null);
    const [wrongEmails, setWrongEmails] = (0, react_1.useState)([]);
    const validateEmail = (rawEmail) => {
        return (0, isEmail_1.default)(rawEmail);
    };
    const handleAddEmail = () => {
        if (validateEmail(email)) {
            setEmails([...new Set([...emails, email])]);
            setEmail('');
        }
        else {
            setEmailError(t('email.incorrect'));
        }
    };
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === ',') {
            handleAddEmail();
        }
    };
    const getDropdownTitle = () => {
        if (validateEmail(email)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("img", { className: EmailsInput_module_scss_1.default.icon, src: assets_1.svgBasicAddNew, alt: "" }),
                t('email.add'),
                " \"",
                react_1.default.createElement("b", { className: EmailsInput_module_scss_1.default.addEmailDisplay }, email),
                "\""));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, t('email.empty'));
    };
    (0, react_1.useEffect)(() => {
        if (isSubmitted) {
            submitHandler(emails);
        }
    }, [isSubmitted]);
    (0, react_1.useEffect)(() => {
        disableSubmit(emails.length === 0 || wrongEmails.length > 0);
    }, [emails, wrongEmails]);
    (0, react_1.useEffect)(() => {
        if (errors === null || errors === void 0 ? void 0 : errors.keys()) {
            errors.forEach((error) => {
                setWrongEmails((prev) => [...new Set([...(prev || []), ...Object.keys(error)])]);
            });
        }
    }, [errors]);
    (0, react_1.useEffect)(() => {
        var _a;
        const handleFocus = () => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', handleFocus);
    }, []);
    return (react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.container },
        react_1.default.createElement("span", null, t('email.title')),
        react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.wrapper, ref: wrapperRef },
            react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.emails },
                emails.map((em) => {
                    const dataError = !wrongEmails ? false : wrongEmails.includes(em);
                    return (react_1.default.createElement("div", { key: em, className: EmailsInput_module_scss_1.default.emailWrapper, "data-error": dataError },
                        react_1.default.createElement("p", { className: EmailsInput_module_scss_1.default.email }, em),
                        react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.close },
                            react_1.default.createElement(CloseButton_1.default, { onCLickHandler: () => {
                                    setEmails(emails.filter((m) => m !== em));
                                    setWrongEmails(wrongEmails.filter((m) => m !== em));
                                    if (editErrors && errors) {
                                        editErrors(errors.filter((err) => Object.keys(err)[0] !== em));
                                    }
                                } }))));
                }),
                react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.inputArea, "data-placeholder": Boolean(emails.length) },
                    react_1.default.createElement("input", { ref: inputRef, placeholder: emails.length ? undefined : t('email.placeholder'), value: email, onKeyDown: onKeyDownHandler, onInput: (e) => {
                            const newValue = e.target.value.replace(',', '');
                            if (newValue !== email) {
                                setEmailError(null);
                                setEmail(newValue);
                            }
                        }, type: "email", autoFocus: true }),
                    react_1.default.createElement("span", { className: EmailsInput_module_scss_1.default.emailHidden }, email),
                    emailError ? react_1.default.createElement("div", { className: EmailsInput_module_scss_1.default.error },
                        " ",
                        emailError) : null))),
        email.trim().length ? (react_1.default.createElement("button", { type: "button", className: EmailsInput_module_scss_1.default.dropdown, onClick: handleAddEmail, onKeyDown: onKeyDownHandler, "data-valid": (0, isEmail_1.default)(email) }, getDropdownTitle())) : null));
}
EmailsInput.defaultProps = {
    errors: undefined,
    editErrors: undefined,
};
exports.default = EmailsInput;
